import React from 'react';
import { Box, Fade, Container, Typography } from '@mui/material';
import RoomSelector from './RoomSelector';
import ItemList from './ItemList';
import { Room } from '../types';
import { cacheService } from '../../functions/services/cacheService';

interface FloorContentProps {
  floorId: string;
  rooms: Room[];
  selectedRooms: string[];
  roomDetails: Record<string, { customName?: string; notes?: string }>;
  onRoomChange: (roomIds: string[], details: Record<string, { customName?: string; notes?: string }>) => void;
  onItemsChange: (items: { itemId: string; quantity: number; roomId: string; isCustom?: boolean; unitPrice?: number }[]) => void;
  onSubmit: () => void;
}

const FloorContent: React.FC<FloorContentProps> = ({
  floorId,
  rooms,
  selectedRooms,
  roomDetails,
  onRoomChange,
  onItemsChange,
  onSubmit
}) => {
  // Get the floor name from the cached etages
  const cachedEtages = cacheService.getEtages();
  const floorInfo = cachedEtages.find(etage => etage.id === floorId);
  const floorName = floorInfo?.name || floorId;

  return (
    <Box 
      role="tabpanel" 
      id={`floor-tabpanel-${floorId}`} 
      aria-labelledby={`floor-tab-${floorId}`}
      sx={{
        py: 3,
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 3
      }}
    >
      <Container maxWidth="lg" sx={{ flex: 1 }}>
        <Fade in timeout={500}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            {/* <Typography variant="h6" gutterBottom>
              {floorName}
            </Typography> */}
            <RoomSelector
              rooms={rooms}
              selectedRooms={selectedRooms}
              roomDetails={roomDetails}
              onRoomChange={onRoomChange}
              onSubmit={onSubmit}
            />
            {selectedRooms.length > 0 && (
              <ItemList
                selectedRooms={selectedRooms}
                rooms={rooms}
                onItemsChange={onItemsChange}
              />
            )}
          </Box>
        </Fade>
      </Container>
    </Box>
  );
};

export default FloorContent; 